module.exports = __webpack_public_path__ + "static/media/help_business_profile_save.6262682d.jpg";